import { useContext, useState, useEffect, useRef, useCallback } from "react"
import OneModal from "../OneModal/OneModal"
import { Grid, Typography } from "@mui/material"
import { showNotify, empty } from "../../Utils/Utils"
import { VisitantesContext } from "../../Providers/VisitantesContext/VisitantesContext"
import OneSelect from "../OneSelect/OneSelect"
import OneButton from "../OneButton/OneButton"
import { AccountCircle, Search, Save } from "@mui/icons-material"
import WebCam from "../Webcam/Webcam"
import BenuvemPlayer from "../../Pages/MonitoramentoPage/Camera/benuvemPlayer"
// propriedadeImagemCapturada é o nome da propriedade que será usada para armazenar a imagem capturada sendo IMAGEMDOCUMENTO ou IMAGEMDOCUMENTO2
// Estado global para manter imagens capturadas não salvas por propriedade
const imagensCapturadasNaoSalvas = {}

const AnexosVisitante = ({ open, setOpen, titleText, setImagemVisitante, caminhoImagem, propriedadeImagemCapturada }) => {
    console.log('caminhoImagem', caminhoImagem)
    const [camerasParaDoc, setCamerasParaDoc] = useState([{ id: 0, nome_exibicao: 'Selecione...' }])
    const [cameraSelecionada, setCameraSelecionada] = useState(0)
    const [cameraAtual, setCameraAtual] = useState(null)
    const [linkImagemCamera, setLinkImagemCamera] = useState(null)
    const [imagemCapturada, setImagemCapturada] = useState(null)
    const [modalCam, setModalCam] = useState(false)
    const fileInputRef = useRef(null)
    const timerCameraRef = useRef(null)
    const cameraBlobUrlRef = useRef(null)
    const cameraAtualRef = useRef(null)
    const preferInternalLinkRef = useRef((typeof global !== 'undefined' ? global.tipoLink !== 'externo' : true))
    const isMountedRef = useRef(true)
    const imagemCameraRef = useRef(null)
    const { addRoute, sendWs, activeCond } = useContext(VisitantesContext)

    const construirUrlCamera = (linkBase, nomeCamera, cameraObj = null) => {
        if (!linkBase || !nomeCamera) {
            return linkBase
        }

        // Se o nome da câmera contém apenas caracteres simples, pode precisar de um nome completo
        // Tentar construir nome completo se necessário: id_central - nome - id_central nome_exibicao
        let nomeFinal = nomeCamera

        // Se a câmera tem informações adicionais, tentar construir nome completo
        // Exemplo: "2000 - 02 - 2000  One Portraia"
        // Mas primeiro verificar se a propriedade 'camera' já contém o nome completo
        if (cameraObj && cameraObj.camera) {
            // Se a propriedade 'camera' existe, usar ela diretamente
            nomeFinal = cameraObj.camera
        } else if (cameraObj && cameraObj.id_central) {
            // Tentar padrão: id_central - nome/id - id_central nome_exibicao
            const idCentral = cameraObj.id_central
            // Formatar ID com zero à esquerda se necessário (02 em vez de 2)
            const id = cameraObj.id || cameraObj.id_camera || cameraObj.cd_camera || 2
            const idFormatado = String(id).padStart(2, '0')
            const nomeExibicao = cameraObj.nome_exibicao || cameraObj.descricao || nomeCamera

            // Verificar se já tem um padrão completo no nome
            if (!nomeCamera.includes(idCentral)) {
                // Construir nome no formato: "2000 - 02 - 2000  One Portraia"
                nomeFinal = `${idCentral} - ${idFormatado} - ${idCentral}  ${nomeExibicao}`
            }
        }

        try {
            const url = new URL(linkBase)
            // Adicionar ou atualizar o parâmetro camera com o nome da câmera (URL encoded)
            // O searchParams.set já faz URL encoding automaticamente
            url.searchParams.set('camera', nomeFinal)
            // Adicionar timestamp para evitar cache
            url.searchParams.set('d', new Date().getTime().toString())
            return url.toString()
        } catch (error) {
            // Se não for uma URL válida, tentar adicionar o parâmetro manualmente
            const separator = linkBase.includes('?') ? '&' : '?'
            const cameraEncoded = encodeURIComponent(nomeFinal)
            return `${linkBase}${separator}camera=${cameraEncoded}&d=${new Date().getTime()}`
        }
    }

    const getNomeCameraParaUrl = (camera) => {
        if (!camera) {
            return ''
        }
        const { camera: cameraProp, nome_camera, nome_exibicao, nome, descricao } = camera
        return cameraProp || nome_camera || nome_exibicao || nome || descricao || ''
    }

    const appendOrUpdateParam = (url, key, value) => {
        if (!url || value === undefined || value === null) {
            return url
        }

        const valueStr = typeof value === 'string' ? value : String(value)

        try {
            const parsed = new URL(url)
            parsed.searchParams.set(key, valueStr)
            return parsed.toString()
        } catch (error) {
            const regex = new RegExp(`([?&])${key}=[^&]*`, 'i')
            if (regex.test(url)) {
                return url.replace(regex, `$1${key}=${encodeURIComponent(valueStr)}`)
            }
            const separator = url.includes('?') ? '&' : '?'
            return `${url}${separator}${key}=${encodeURIComponent(valueStr)}`
        }
    }

    const clearCameraTimer = useCallback(() => {
        if (timerCameraRef.current) {
            clearTimeout(timerCameraRef.current)
            timerCameraRef.current = null
        }
    }, [])

    const cleanupCameraObjectUrl = useCallback(() => {
        if (cameraBlobUrlRef.current) {
            URL.revokeObjectURL(cameraBlobUrlRef.current)
            cameraBlobUrlRef.current = null
        }
    }, [])

    const stopCameraPolling = useCallback(() => {
        clearCameraTimer()
        cleanupCameraObjectUrl()
    }, [clearCameraTimer, cleanupCameraObjectUrl])

    const setCameraImage = useCallback((value) => {
        if (isMountedRef.current) {
            setLinkImagemCamera(value)
        }
    }, [])

    const getCameraBaseLink = useCallback((camera) => {
        if (!camera) {
            return null
        }

        const linkInterno = camera.linkInterno || camera.link2
        const linkExterno = camera.linkExterno || camera.link

        if (preferInternalLinkRef.current && linkInterno) {
            return linkInterno
        }
        if (!preferInternalLinkRef.current && linkExterno) {
            return linkExterno
        }
        return linkInterno || linkExterno || null
    }, [])

    const buildSigmaLink = (linkBase, camera) => {
        if (!camera || !linkBase) {
            return linkBase
        }

        const nomeCameraParaUrl = getNomeCameraParaUrl(camera)
        let finalLink = construirUrlCamera(linkBase, nomeCameraParaUrl, camera)

        if (camera.senha && finalLink && finalLink.indexOf('AuthPass=') === -1) {
            finalLink = appendOrUpdateParam(finalLink, 'AuthPass', camera.senha)
        }

        if (!finalLink) {
            finalLink = appendOrUpdateParam(linkBase, 'd', new Date().getTime())
        }

        return finalLink
    }

    const buildOutroSistemaLink = (linkBase, camera) => {
        if (!camera || !linkBase) {
            return linkBase
        }

        let link = linkBase

        if (link.includes('#USUARIO')) {
            link = link.replace('#USUARIO', !empty(camera.usuario) ? camera.usuario : '')
        }

        if (link.includes('#SENHA')) {
            link = link.replace('#SENHA', !empty(camera.senha) ? camera.senha : '')
        }

        link = appendOrUpdateParam(link, 'camera', camera.camera)

        return appendOrUpdateParam(link, 'd', new Date().getTime())
    }

    const carregarImagemDGuard = useCallback(async (camera, linkBase) => {
        if (!camera || !linkBase) {
            return
        }

        const cameraIndex = camera.camera !== undefined && camera.camera !== null ? Number(camera.camera) - 1 : null
        let finalLink = linkBase

        if (cameraIndex !== null && !Number.isNaN(cameraIndex)) {
            const cameraValue = cameraIndex < 0 ? 0 : cameraIndex
            finalLink = appendOrUpdateParam(finalLink, 'camera', cameraValue)
        }

        finalLink = appendOrUpdateParam(finalLink, 'd', new Date().getTime())

        const usuario = camera.usuario || ''
        const senha = camera.senha || ''
        const token = btoa(`${usuario}:${senha}`)

        const response = await fetch(finalLink, {
            method: 'GET',
            headers: {
                Authorization: `Basic ${token}`,
                SameSite: 'none'
            }
        })

        if (!response.ok) {
            throw new Error(`Erro ao carregar câmera DGuard: ${response.status}`)
        }

        const blob = await response.blob()
        cleanupCameraObjectUrl()
        const objectUrl = URL.createObjectURL(blob)
        cameraBlobUrlRef.current = objectUrl
        setCameraImage(objectUrl)
    }, [cleanupCameraObjectUrl, setCameraImage])

    const atualizarImagemCamera = useCallback(async () => {
        const camera = cameraAtualRef.current

        if (!camera || camera.live_ws) {
            return
        }

        const linkBase = getCameraBaseLink(camera)

        if (!linkBase) {
            setCameraImage(null)
            return
        }

        const tipoSistema = (camera.tipo_sistema || '').toLowerCase()
        const tipoCamera = Number(camera.tipoCamera)

        try {
            if (tipoSistema === 'padrao') {
                if (tipoCamera === 2) {
                    await carregarImagemDGuard(camera, linkBase)
                } else {
                    const sigmaLink = buildSigmaLink(linkBase, camera)
                    setCameraImage(sigmaLink)
                }
            } else if (tipoSistema === 'outro') {
                const outroLink = buildOutroSistemaLink(linkBase, camera)
                setCameraImage(outroLink)
            } else {
                setCameraImage(appendOrUpdateParam(linkBase, 'd', new Date().getTime()))
            }
        } catch (error) {
            console.error('Erro ao atualizar imagem da câmera:', error)
            if (preferInternalLinkRef.current && (camera.linkExterno || camera.link)) {
                preferInternalLinkRef.current = false
            }
            setCameraImage(null)
        } finally {
            if (cameraAtualRef.current && cameraAtualRef.current.id === camera.id) {
                timerCameraRef.current = setTimeout(() => {
                    atualizarImagemCamera()
                }, 500)
            }
        }
    }, [carregarImagemDGuard, getCameraBaseLink, setCameraImage])

    useEffect(() => {
        if (open) {
            buscarCamerasParaDoc()
            setCameraSelecionada(0)
            setCameraAtual(null)
            setCameraImage(null)
        }
    }, [open, setCameraImage])

    // Efeito para inicializar a imagem quando o modal abre
    useEffect(() => {
        if (open) {
            // Verificar se há uma imagem capturada não salva para esta propriedade
            const imagemNaoSalva = imagensCapturadasNaoSalvas[propriedadeImagemCapturada]

            if (imagemNaoSalva) {
                // Se houver imagem capturada não salva, usar ela
                setImagemCapturada(imagemNaoSalva)
            } else if (caminhoImagem && caminhoImagem !== '') {
                // Se não houver imagem capturada não salva, usar o caminhoImagem (imagem salva)
                setImagemCapturada(caminhoImagem)
            } else {
                // Se não houver nenhum dos dois, limpar
                setImagemCapturada(null)
            }
        }
    }, [open, caminhoImagem, propriedadeImagemCapturada])

    useEffect(() => {
        if (cameraSelecionada !== 0) {
            const camera = camerasParaDoc.find(cam => cam.id === cameraSelecionada)
            if (camera) {
                setCameraAtual(camera)
                setImagemCapturada(null)
            } else {
                setCameraAtual(null)
                setCameraImage(null)
                setImagemCapturada(null)
            }
        } else {
            setCameraAtual(null)
            setCameraImage(null)
            setImagemCapturada(null)
        }
    }, [cameraSelecionada, camerasParaDoc, setCameraImage])

    useEffect(() => {
        cameraAtualRef.current = cameraAtual
    }, [cameraAtual])

    useEffect(() => {
        stopCameraPolling()

        if (!cameraAtual) {
            setCameraImage(null)
            return
        }

        if (cameraAtual.live_ws) {
            setCameraImage(null)
            return
        }

        if (typeof global !== 'undefined') {
            preferInternalLinkRef.current = global.tipoLink !== 'externo'
        } else {
            preferInternalLinkRef.current = true
        }

        atualizarImagemCamera()

        return () => {
            stopCameraPolling()
        }
    }, [cameraAtual, atualizarImagemCamera, setCameraImage, stopCameraPolling])

    useEffect(() => {
        return () => {
            isMountedRef.current = false
            stopCameraPolling()
        }
    }, [stopCameraPolling])

    const buscarCamerasParaDoc = async () => {
        if (!activeCond || !activeCond.id_central) {
            showNotify('warning', 'Selecione um condomínio para buscar câmeras')
            return
        }
        addRoute('buscarCamerasAtivasApp', buscarCamerasParaDocResposta)
        sendWs('buscarCamerasAtivasApp', { id_central: activeCond.id_central })
    }

    const buscarCamerasParaDocResposta = (msg) => {
        if (msg.data && msg.data.status) {
            const cameras = msg.data.cameras || []
            setCamerasParaDoc([{ id: 0, nome_exibicao: 'Selecione...' }, ...cameras])
        } else {
            const errorMessage = msg.data?.message || msg.data?.RESPONSE_MESSAGE || 'Erro ao buscar câmeras para documentos'
            showNotify('error', errorMessage)
        }
    }

    const capturarImagemAtual = async () => {
        try {
            if (!activeCond || !activeCond.id_central) {
                showNotify('warning', 'Selecione um condomínio antes de capturar')
                return
            }

            if (!cameraAtual) {
                showNotify('warning', 'Selecione uma câmera antes de capturar')
                return
            }

            // Construir o caminho para a pasta web que está um nível acima do projeto
            const baseOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : ''
            const sanitizedOrigin = baseOrigin ? baseOrigin.replace(':3003', '') : ''
            const url = `${sanitizedOrigin}/wsOnePortaria/web/save_snapshot_camera.php`

            // Determinar tipoFoto baseado na propriedadeImagemCapturada
            let tipoFoto = 'documento'
            if (propriedadeImagemCapturada === 'IMAGEMDOCUMENTO2') {
                tipoFoto = 'documento2'
            } else if (propriedadeImagemCapturada === 'IMAGEMDOCUMENTO') {
                tipoFoto = 'documento'
            }

            // Converter objeto cam para formato de parâmetros aninhados (cam[propriedade])
            const buildCamParams = (camObj) => {
                const params = new URLSearchParams()
                if (camObj) {
                    // Mapear propriedades para os nomes esperados pelo PHP
                    const propertyMap = {
                        linkInterno: 'link2',
                        linkExterno: 'link'
                    }

                    Object.keys(camObj).forEach(key => {
                        const value = camObj[key]
                        // Usar nome mapeado se existir, senão usar o nome original
                        const paramKey = propertyMap[key] || key

                        // Converter valores booleanos e null para o formato esperado
                        let finalValue = value
                        if (value === null || value === undefined) {
                            finalValue = ''
                        } else if (typeof value === 'boolean') {
                            finalValue = value ? '1' : '0'
                        } else if (typeof value === 'object' && value.constructor === Date) {
                            finalValue = value.toISOString()
                        } else {
                            finalValue = String(value)
                        }
                        params.append(`cam[${paramKey}]`, finalValue)
                    })
                }
                return params
            }

            // Construir o body com os parâmetros corretos
            const camParams = buildCamParams(cameraAtual)
            camParams.append('tipoFoto', tipoFoto)
            camParams.append('id_central', String(activeCond.id_central))
            camParams.append('df', Math.random().toString())

            console.log('Fazendo requisição para:', url)
            console.log('Dados enviados:', {
                cam: cameraAtual,
                tipoFoto,
                id_central: activeCond.id_central,
                df: Math.random()
            })

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: camParams.toString()
            })
            const dados = await response.json()

            if (dados.status !== 'ok') {
                throw new Error(`Erro HTTP: ${dados.status} ${dados.statusText}`)
            }

            const caminhoImagem = `./${dados.name}`

            const name = propriedadeImagemCapturada == 'IMAGEMDOCUMENTO' ? 'imgDocumento' : 'imgDocumento2'
            const value = caminhoImagem
            setImagemVisitante({ name, value })
            // Limpar a imagem não salva quando a imagem é salva
            delete imagensCapturadasNaoSalvas[propriedadeImagemCapturada]
            showNotify('success', 'Imagem capturada com sucesso!')
            setOpen(false)
        } catch (error) {
            console.error('Erro ao capturar imagem atual:', error)

            showNotify('error', error.message || 'Erro ao capturar imagem atual')
        }
    }

    const handleCapturarPerfil = () => {
        if (cameraSelecionada === 0) {
            showNotify('warning', 'Selecione uma câmera antes de capturar')
            return
        }

        // Se não houver imagem da câmera sendo exibida, abrir modal de webcam
        if (!linkImagemCamera && (!cameraAtual || !cameraAtual.live_ws)) {
            setModalCam(true)
            return
        }

        // Capturar a imagem atual sendo exibida
        capturarImagemAtual()
    }

    const fotoCapturada = (base64img) => {
        // Salvar no objeto global para persistir entre aberturas do modal
        imagensCapturadasNaoSalvas[propriedadeImagemCapturada] = base64img
        setImagemCapturada(base64img)
        setModalCam(false)
    }

    const handleProcurar = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            const reader = new FileReader()
            reader.onloadend = () => {
                // Salvar no objeto global para persistir entre aberturas do modal
                imagensCapturadasNaoSalvas[propriedadeImagemCapturada] = reader.result
                setImagemCapturada(reader.result)
            }
            reader.readAsDataURL(file)
        }
    }

    const handleSalvar = () => {
        if (!imagemCapturada) {
            showNotify('warning', 'Nenhuma imagem capturada para salvar')
            return
        }

        if (setImagemVisitante) {
            const name = propriedadeImagemCapturada == 'IMAGEMDOCUMENTO' ? 'imgDocumento' : 'imgDocumento2'
            // Passar apenas a string base64 - a propriedade será usada na função setAnexoVisitante
            setImagemVisitante({ name, value: imagemCapturada })
            // Limpar a imagem não salva quando a imagem é salva
            delete imagensCapturadasNaoSalvas[propriedadeImagemCapturada]
            showNotify('success', 'Imagem salva com sucesso!')
            setOpen(false)
        } else {
            showNotify('error', 'Função de salvar imagem não disponível')
        }
    }
    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                titleText={titleText}
                fullWidth={true}
            >
                <Grid container sx={{
                    backgroundColor: '#D9D9D9',
                    borderRadius: '5px',
                    display: 'flex',
                    flexGrow: 1,
                    height: '100%',
                    width: '100%'
                }}>
                    <Grid container xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'row', gap: 1 }}>
                        <Grid xs={8} sx={{ height: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
                            {imagemCapturada && imagemCapturada !== ''
                                ? (
                                    <img
                                        ref={imagemCameraRef}
                                        src={imagemCapturada}
                                        alt="Imagem Capturada"
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    />
                                )
                                : cameraAtual && cameraAtual.live_ws
                                    ? (
                                        <BenuvemPlayer
                                            style={{ width: '100%', height: '100%' }}
                                            url={cameraAtual.live_ws}
                                            cameraPrincipal={false}
                                            snapshot={cameraAtual.snapshot || ''}
                                        />
                                    )
                                    : linkImagemCamera
                                        ? (
                                            <img
                                                ref={imagemCameraRef}
                                                src={linkImagemCamera}
                                                alt="Preview da Câmera"
                                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                onError={(e) => {
                                                    setCameraImage(null)
                                                }}
                                            />
                                        )
                                        : caminhoImagem && caminhoImagem !== ''
                                            ? (
                                                <img ref={imagemCameraRef} src={caminhoImagem} alt="Imagem do Anexo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                            )
                                            : null}
                        </Grid>
                        <Grid xs={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1, padding: '10px' }}>
                            <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>{titleText}</Typography>

                            <Typography sx={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>Escolha a Câmera</Typography>

                            <OneSelect
                                options={camerasParaDoc}
                                value={cameraSelecionada}
                                onChange={(e) => setCameraSelecionada(Number(e.target.value))}
                                label="nome_exibicao"
                                valor="id"
                                newSx={{
                                    '& .MuiSelect-select': {
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px'
                                    }
                                }}
                            />

                            <Grid sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginTop: '10px' }}>
                                <OneButton
                                    variant="contained"
                                    color="one_primary"
                                    backgroundColor='true'
                                    IconStart={AccountCircle}
                                    sxIconStart={{ width: '20px', color: 'white' }}
                                    onClick={handleCapturarPerfil}
                                    disabled={cameraSelecionada === 0}
                                >
                                    Capturar Documento
                                </OneButton>

                                <OneButton
                                    variant="contained"
                                    color="warning"
                                    backgroundColor='true'
                                    IconStart={Search}
                                    sxIconStart={{ width: '20px', color: 'white' }}
                                    onClick={handleProcurar}
                                >
                                    Procurar...
                                </OneButton>

                                {imagemCapturada && (
                                    <OneButton
                                        variant="contained"
                                        color="success"
                                        backgroundColor='true'
                                        IconStart={Save}
                                        sxIconStart={{ width: '20px', color: 'white' }}
                                        onClick={handleSalvar}
                                    >
                                        Salvar
                                    </OneButton>
                                )}
                            </Grid>

                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </OneModal>

            <WebCam
                open={modalCam}
                setOpen={setModalCam}
                retornoFunc={fotoCapturada}
                cropActive={true}
            />
        </>
    )
}

export default AnexosVisitante
